export default class PhoneNumberHelper {
  static startsWithValidDigits(phoneNumber) {
    const validDigits = '6789'.split('');
    return validDigits.some(digit => phoneNumber.startsWith(digit));
  }

  static getFormattedPhoneNumber(phoneNumber) {
    const matchNumbers = /^\d+$/;
    const specialChars = /[-()\s]/g;
    const indianPrefixes = ['0', '91', '+91'];
    let isValid = true;
    let errorMessage = 'Please enter a valid mobile number';
    let formattedPhoneNumber = phoneNumber;
    formattedPhoneNumber = formattedPhoneNumber.replace(specialChars, '');
    if (formattedPhoneNumber.length > 10) {
      for (const prefix of indianPrefixes) {
        const numberLengthWithPrefix = 10 + prefix.length;
        if (formattedPhoneNumber.startsWith(prefix)
        && formattedPhoneNumber.length === numberLengthWithPrefix) {
          formattedPhoneNumber = formattedPhoneNumber.slice(prefix.length);
          break;
        }
      }
    }
    if (!formattedPhoneNumber && phoneNumber.length !== formattedPhoneNumber.length) {
      isValid = false;
    }
    if (formattedPhoneNumber.length > 10) isValid = false;
    if (formattedPhoneNumber && !matchNumbers.test(formattedPhoneNumber)) {
      isValid = false;
      errorMessage = 'Phone number may only contain digits (0-9)';
    }
    if (isValid && formattedPhoneNumber
      && !PhoneNumberHelper.startsWithValidDigits(formattedPhoneNumber)) {
      isValid = false;
      errorMessage = 'Phone number must start with 6, 7, 8 or 9';
    }
    return {
      isValid,
      number: formattedPhoneNumber,
      errorMessage,
    };
  }
}

export async function createCookieInHour(cookieName, cookieValue, hourToExpire) {
  const date = new Date();
  date.setTime(date.getTime() + hourToExpire * 60 * 60 * 1000);
  document.cookie = `${cookieName}=${cookieValue}; expires =${date.toGMTString()};`;
}

export async function createCookie(cookieName, cookieValue) {
  const date = new Date();
  date.setTime(date.getTime() + 7 * 24 * 60 * 60 * 1000);
  const cookieString = `${cookieName}=${cookieValue}; expires=${date.toUTCString()}; path=/;`;
  document.cookie = cookieString;
}

export function deleteCookie(cookieName) {
  document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}

export async function getCookieByName(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop().split(';').shift();
  }
  return undefined;
}
